module.exports = __webpack_public_path__ + "img/ioc5.a2722911.png";